export default "__VITE_ASSET__DaFcTCEI__"